import { OrganisationRole } from '@heidi/schema/ml-scribe';
import { defineMessages, type MessageDescriptor } from 'react-intl';

/** Copy shared across signup surfaces and account settings — single Crowdin unit per string. */
export const sharedSignupMessages = defineMessages({
  requiredFieldMarker: {
    defaultMessage: '*',
    id: '59hMcPu8/B',
    description:
      'Asterisk after required field labels on signup (modal, email-only flow, etc.)',
  },
  organisationRoleExecutiveTeam: {
    defaultMessage: 'Executive team (CIO, CMIO, CEO etc.)',
    id: 'eOyBz0zyBl',
    description: 'Organisation role option: executive or technology leadership',
  },
  organisationRoleIndividualClinician: {
    defaultMessage: 'Individual clinician',
    id: 'B6CJZygobD',
    description: 'Organisation role option: practising clinician without admin role',
  },
  organisationRoleLead: {
    defaultMessage: 'Clinical lead, department lead, head of …',
    id: 'IiaLILPI/k',
    description: 'Organisation role option: clinical or department leadership',
  },
  organisationRoleOwnerOrPracticeManager: {
    defaultMessage: 'Owner or practice manager',
    id: 'bWscaMjtn/',
    description: 'Organisation role option: owner or practice manager',
  },
});

/** Shared label map for the OrganisationRole enum (signup + onboarding role selects). */
export const ORGANISATION_ROLE_MESSAGE: Record<OrganisationRole, MessageDescriptor> = {
  [OrganisationRole.EXECUTIVE_TEAM]: sharedSignupMessages.organisationRoleExecutiveTeam,
  [OrganisationRole.INDIVIDUAL_CLINICIAN]:
    sharedSignupMessages.organisationRoleIndividualClinician,
  [OrganisationRole.LEAD]: sharedSignupMessages.organisationRoleLead,
  [OrganisationRole.OWNER_OR_PRACTICE_MANAGER]:
    sharedSignupMessages.organisationRoleOwnerOrPracticeManager,
};
